// © Microsoft Corporation. All rights reserved.

import { createElement } from "react";
import val from "@skatejs/val";

export default val(createElement);